import React, { useState } from "react";
import FoodShell from "../../layouts/FoodShell";
import { appModules } from "../../components/global";
import { alert } from "../../components/CustomComponent";
import { pantryDefaults, pantrySuggestions, recipes } from "./mockData";
import { Panel, Section, Chip } from "./FoodUi";

// "กินอะไรดีจากของที่มีอยู่": เลือกวัตถุดิบ (หรือถ่ายรูปตู้เย็น) แล้ว AI แนะนำเมนูที่ทำได้พร้อมวิธีทำ (จำลอง)
export default function FoodPantry() {
  const { title, description } = appModules["food_pantry"];
  const [items, setItems] = useState(pantryDefaults);
  const [input, setInput] = useState("");
  const [scanned, setScanned] = useState(true);
  const [openRecipe, setOpenRecipe] = useState(1);

  const addItem = (name) => {
    const value = String(name || "").trim();
    if (!value || items.includes(value)) return;
    setItems([...items, value]);
    setInput("");
  };
  const removeItem = (name) => setItems(items.filter((item) => item !== name));

  // เมนูที่ทำได้ = มีวัตถุดิบครบ; แสดงเมนูที่ขาด 1 อย่างไว้ด้วยเป็น "เกือบทำได้"
  const scored = recipes
    .map((recipe) => ({ ...recipe, missing: recipe.uses.filter((use) => !items.includes(use)) }))
    .sort((a, b) => a.missing.length - b.missing.length || a.rank - b.rank);

  const fakeScan = async () => {
    setScanned(false);
    await new Promise((resolve) => setTimeout(resolve, 900));
    setItems([...new Set([...items, ...pantryDefaults])]);
    setScanned(true);
    await alert("", "success", "อ่านรูปแล้ว", `AI เห็น: ${pantryDefaults.join(", ")} (จำลอง ยังไม่เชื่อมกล้อง/AI จริง)`);
  };

  return (
    <FoodShell title={title} description={description}>
      <div className="row g-3">
        <div className="col-xl-5">
          <Panel eyebrow="Pantry" icon="fa-solid fa-carrot" title="ของที่มีอยู่" desc="(ตัวอย่าง ยังไม่เชื่อม AI อ่านรูปจริง) ถ่ายรูปตู้เย็นหรือพิมพ์เพิ่มเอง AI จะดูว่าทำอะไรได้บ้าง">
            <button type="button" className="food-scan" onClick={fakeScan} disabled={!scanned}>
              <span className="food-scan-icon"><i className={scanned ? "fa-solid fa-camera" : "fa-solid fa-spinner fa-spin"} /></span>
              <span>
                <strong>{scanned ? "ถ่ายรูปตู้เย็น" : "AI กำลังดูรูป..."}</strong>
                <small>AI จะอ่านวัตถุดิบจากรูปให้อัตโนมัติ</small>
              </span>
            </button>

            <label className="stg-label mt-3">วัตถุดิบที่มี ({items.length})</label>
            <div className="food-pantry-list">
              {items.map((item) => (
                <Chip key={item} tone="orange" className="food-pantry-chip">
                  {item}
                  <button type="button" className="food-chip-x" aria-label={`ลบ ${item}`} onClick={() => removeItem(item)}><i className="fa-solid fa-xmark" /></button>
                </Chip>
              ))}
              {!items.length ? <span className="text-secondary small">ยังไม่มีวัตถุดิบ เพิ่มด้านล่างหรือถ่ายรูปตู้เย็น</span> : null}
            </div>
            <div className="stg-search mt-2">
              <i className="fa-solid fa-plus" />
              <input type="text" className="form-control" value={input} placeholder="พิมพ์วัตถุดิบแล้วกด Enter" onChange={(event) => setInput(event.target.value)} onKeyDown={(event) => { if (event.key === "Enter") addItem(input); }} />
            </div>
            <div className="mt-2 d-flex flex-wrap gap-1">
              {pantrySuggestions.filter((item) => !items.includes(item)).map((item) => (
                <Chip key={item} tone="muted" icon="fa-solid fa-plus" onClick={() => addItem(item)}>{item}</Chip>
              ))}
            </div>
          </Panel>
        </div>

        <div className="col-xl-7">
          <Section icon="fa-solid fa-robot" title="ทำอะไรดี?" desc="AI จัดอันดับเมนูจากวัตถุดิบที่มี เป้าหมาย และพลังงานที่เหลือวันนี้">
            <div className="d-grid gap-2">
              {scored.map((recipe) => {
                const canMake = recipe.missing.length === 0;
                const open = openRecipe === recipe.id;
                return (
                  <div key={recipe.id} className={`food-recipe ${canMake ? "" : "is-missing"} ${open ? "is-open" : ""}`}>
                    <button type="button" className="food-recipe-head" onClick={() => setOpenRecipe(open ? null : recipe.id)}>
                      <span className={`food-rank food-rank--${recipe.rank}`}>{recipe.rank === 1 ? "🥇" : recipe.rank === 2 ? "🥈" : "🥉"}</span>
                      <span className="food-card-emoji">{recipe.emoji}</span>
                      <span style={{ flex: 1, minWidth: 0 }}>
                        <span className="food-card-name d-block">{recipe.name}</span>
                        <span className="food-nutri">
                          <span><i className="fa-solid fa-fire" />ประมาณ {recipe.kcal} kcal</span>
                          <span><i className="fa-solid fa-drumstick-bite" />P {recipe.protein} g</span>
                          <span><i className="fa-regular fa-clock" />{recipe.minutes} นาที</span>
                        </span>
                      </span>
                      {canMake ? <span className="stg-pill stg-pill--success">ทำได้เลย</span> : <span className="stg-pill stg-pill--gold">ขาด {recipe.missing.join(", ")}</span>}
                      <i className={`fa-solid fa-chevron-down food-recipe-caret ${open ? "is-open" : ""}`} />
                    </button>
                    {open ? (
                      <div className="food-recipe-body">
                        <div className="food-subhead">ใช้วัตถุดิบ</div>
                        <div className="d-flex flex-wrap gap-1 mb-3">
                          {recipe.uses.map((use) => <Chip key={use} tone={items.includes(use) ? "green" : "red"} icon={items.includes(use) ? "fa-solid fa-check" : "fa-solid fa-xmark"}>{use}</Chip>)}
                        </div>
                        <div className="food-subhead">วิธีทำ</div>
                        <ol className="food-steps-list">
                          {recipe.steps.map((step) => <li key={step}>{step}</li>)}
                        </ol>
                        <div className="d-flex flex-wrap gap-2 mt-3">
                          <button type="button" className="btn stg-btn stg-btn--primary stg-btn--sm" onClick={() => alert("", "success", "บันทึกแล้ว", `เพิ่ม "${recipe.name}" ในบันทึกวันนี้ (จำลอง)`)}><i className="fa-solid fa-check" />ทำเมนูนี้</button>
                          <button type="button" className="btn stg-btn stg-btn--ghost stg-btn--sm" onClick={() => alert("", "success", "เก็บแล้ว", "เพิ่มในเมนูที่เก็บไว้ (จำลอง)")}><i className="fa-regular fa-heart" />เก็บไว้</button>
                        </div>
                      </div>
                    ) : null}
                  </div>
                );
              })}
            </div>
          </Section>
        </div>
      </div>
    </FoodShell>
  );
}
